import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/zh-cn/services/$slug")({
  head: ({ params }) => buildRouteHead(`/zh-cn/services/${params.slug}`),
  component: ServicePage,
});

